import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';

import { useClaimProfile } from '../hooks/useClaimProfile';
import { ClaimHeader } from '../components/claimHeader';
import { ProfileForm } from '../components/profileForm';
import { VerifyEmail } from '../../../components/molecules/verifyEmail';

export const Profile = ({ activeNetwork, company, isOnboarding }) => {
  const { initialValues, formSchema, onSubmit, isLoading, formRef, status } = useClaimProfile({
    company,
    activeNetwork,
    isOnboarding,
  });

  return (
    <Flex flexDirection="column" sx={{ gap: '56px', maxWidth: '360px', mx: 'auto', mt: '100px' }}>
      <ClaimHeader activeNetwork={activeNetwork} company={company} />
      {(!status || status === 'sign_up') && (
        <ProfileForm
          initialValues={initialValues}
          validationSchema={formSchema}
          onSubmit={onSubmit}
          isLoading={isLoading}
          ref={formRef}
        />
      )}
      {status === 'verify_email' && <VerifyEmail />}
    </Flex>
  );
};

Profile.propTypes = {
  activeNetwork: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  isOnboarding: PropTypes.bool,
};

Profile.defaultProps = {
  isOnboarding: false,
};
